import React, { FC } from 'react';
import MuiCard, { CardProps as MuiCardProps } from '@mui/material/Card';
import Content from '@mui/material/CardContent';
import Actions from '@mui/material/CardActions';
import Header from '@mui/material/CardHeader';
import Media from '@mui/material/CardMedia';
import ActionArea from '@mui/material/CardActionArea';
import { BpDesignSystem } from '../../types';
import { mergeClassNames } from '../../utils/cssClassNameHelper';

export type CardProps = BpDesignSystem.PropsWithChildren<
  MuiCardProps & {
    fullSize?: boolean;
    prominent?: boolean;
  }
>;

const CardBase: FC<CardProps> = ({ dataTest, fullSize, sx, prominent, className, ...props }) => {
  return (
    <MuiCard
      data-test={dataTest}
      className={mergeClassNames(className, {
        'BpCard-prominent': prominent
      })}
      sx={{
        ...(fullSize ? fullSizeStyle : {}),
        ...sx
      }}
      {...props}
    />
  );
};

export const Card = Object.assign(CardBase, {
  Content,
  Actions,
  Header,
  Media,
  ActionArea
});

const fullSizeStyle = {
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column'
} as const;
